export const PARAMETERS = 'parameters';

//DIST026
export const DIST026_TREATMENT_KEY = 'dist-026';
export const DIST026_GROUP_PARAMETER_KEY = 'group';
export const DIST026_STATUS_PARAMETER_KEY = 'status';
export const DIST026_IS_ACTIVE_KEY = 'isActive';
export let DIST026_GROUP_PARAMETER_OPTIONS;

// SSM0001
(function (DIST026_GROUP_PARAMETER_OPTIONS) {
  DIST026_GROUP_PARAMETER_OPTIONS["control"] = "control";
  DIST026_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(DIST026_GROUP_PARAMETER_OPTIONS || (DIST026_GROUP_PARAMETER_OPTIONS = {}));
export const SSM0001_TREATMENT_KEY = 'ssm-0001';
export const SSM0001_GROUP_PARAMETER_KEY = 'group';
export let SSM0001_GROUP_PARAMETER_OPTIONS;

// HC0124 -- due to a critist HC0122 data was unusable and was rekeyed to HC0124
(function (SSM0001_GROUP_PARAMETER_OPTIONS) {
  SSM0001_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSM0001_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(SSM0001_GROUP_PARAMETER_OPTIONS || (SSM0001_GROUP_PARAMETER_OPTIONS = {}));
export const HC0124_TREATMENT_KEY = 'hc-0124';
export const HC0124_GROUP_PARAMETER_KEY = 'group';
export let HC0124_GROUP_PARAMETER_OPTIONS;

// HC0119
(function (HC0124_GROUP_PARAMETER_OPTIONS) {
  HC0124_GROUP_PARAMETER_OPTIONS["control"] = "control";
  HC0124_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(HC0124_GROUP_PARAMETER_OPTIONS || (HC0124_GROUP_PARAMETER_OPTIONS = {}));
export const HC0119_TREATMENT_KEY = 'hc-0119';
export const HC0119_GROUP_PARAMETER_KEY = 'group';
export let HC0119_GROUP_PARAMETER_OPTIONS;

// SSM0004
(function (HC0119_GROUP_PARAMETER_OPTIONS) {
  HC0119_GROUP_PARAMETER_OPTIONS["control"] = "control";
  HC0119_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(HC0119_GROUP_PARAMETER_OPTIONS || (HC0119_GROUP_PARAMETER_OPTIONS = {}));
export const SSM0004_TREATMENT_KEY = 'ssm-0004';
export const SSM0004_GROUP_PARAMETER_KEY = 'group';
export const SSM0004_GROUP_PARAMETER_OPTIONS = Object.freeze({
  control: 'control',
  variant: 'variant'
});

// MC0655
export const MC0655_TREATMENT_KEY = 'mc-0655';
export const MC0655_GROUP_PARAMETER_KEY = 'group';
export let MC0655_GROUP_PARAMETER_OPTIONS;

// SSM0002
(function (MC0655_GROUP_PARAMETER_OPTIONS) {
  MC0655_GROUP_PARAMETER_OPTIONS["control"] = "control";
  MC0655_GROUP_PARAMETER_OPTIONS["variant"] = "variation";
})(MC0655_GROUP_PARAMETER_OPTIONS || (MC0655_GROUP_PARAMETER_OPTIONS = {}));
export const SSM0002_TREATMENT_KEY = 'ssm-0002';
export const SSM0002_GROUP_PARAMETER_KEY = 'group';
export const SSM0002_GROUP_PARAMETER_OPTIONS = Object.freeze({
  control: 'control',
  variant: 'variant'
});